import axios from './axios'

export async function downloadFileService(id: Number) : Promise<Blob> {
    const response = await axios.get(`/api/downloadFile/${id}`) ;
    return response.data;
}

export async function downloadEmergenza(id: Number)   {
    axios.get(`/api/downloadEmergenza/${id}`, { responseType: 'blob' })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Emergenza.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch(error => {
      console.error('Error downloading PDF:', error);
    });
}

export async function previewEmergenza(id: Number)   {
  axios.get(`/api/downloadEmergenza/${id}`, { responseType: 'blob' })
  .then(response => {
    const url = window.URL.createObjectURL(new Blob([response.data], { type: response.data.type }));
    window.open(url, '_blank');
  })
  .catch(error => {
    console.error('Error preveiwing PDF:', error);
  });
}

export async function previewReport(id: Number)   {
  axios.get(`/api/downloadReport/${id}`, { responseType: 'blob' })
  .then(response => {
    const url = window.URL.createObjectURL(new Blob([response.data], { type: response.data.type }));
    window.open(url, '_blank');
  })
  .catch(error => {
    console.error('Error preveiwing PDF:', error);
  });
}

export async function downloadReport(id: Number)   {
    axios.get(`/api/downloadReport/${id}`, { responseType: 'blob'})
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Report.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch(error => {
      console.error('Error downloading PDF:', error);
    });
}

export async function previewTerapie(id: Number)   {
  axios.get(`/api/downloadTerapie/${id}`, { responseType: 'blob' })
  .then(response => {
    const url = window.URL.createObjectURL(new Blob([response.data], { type: response.data.type }));
    window.open(url, '_blank');
  })
  .catch(error => {
    console.error('Error preveiwing PDF:', error);
  });
}

export async function downloadTerapie(id: Number)   {
    axios.get(`/api/downloadTerapie/${id}`, { responseType: 'blob'})
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Report.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch(error => {
      console.error('Error downloading PDF:', error);
    });
}

export async function previewEsami(id: Number)   {
  axios.get(`/api/downloadEsami/${id}`, { responseType: 'blob' })
  .then(response => {
    const url = window.URL.createObjectURL(new Blob([response.data], { type: response.data.type }));
    window.open(url, '_blank');
  })
  .catch(error => {
    console.error('Error preveiwing PDF:', error);
  });
}


// Last modified by: Elena Simonoska
// Last modified on: 13.10.2.23
// Modifications made: Implement print esami, in progress.